import {GET_FAV_VIDEOS, GET_FAV_VIDEOS_START, RESET_FAV_VIDEOS} from '../constants';

const initState = {
	programs: null,
};
const favorite = (state = initState, action) => {
	switch (action.type) {
		case RESET_FAV_VIDEOS:
			return initState;
		case GET_FAV_VIDEOS_START:
			return {
				...state,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: null,
					isLoading: true,
				},
			};
		case GET_FAV_VIDEOS:
			return {
				...state,
				programs: action.pageNumber === 1 ? [...action.programs] : state.programs,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: action.programs,
					isLoading: false,
					pageSize: action.paging.pageSize,
					totalPages: action.paging.totalPages,
					totalCount: action.paging.totalCount,
					hasNextPage: action.paging.hasNextPage,
				},
			};
		default:
			return state;
	}
};

export default favorite;
